<template>
  <ais-infinite-hits v-bind="$attrs" key="variations" id="variations">
    <template v-slot="{ items, isLastPage, refineNext, results }">
      <div>
        <h2 class="text-2xl mb-sm" v-if="items.length !== 1">
          <span v-if="hasAppliedFilters(results) && items.length > 1">
            {{ 'Matching Variations' | t }}
          </span>
          <span v-else>{{ 'All Variations' | t }}</span>
        </h2>
        <Variations
          class="items"
          :items="items"
          :isLastPage="isLastPage"
          :refineNext="refineNext"
          :showEstimatedShipDate="true"
          v-if="items.length > 1"
        >
          <slot name="request-spec-card" />
        </Variations>
      </div>
    </template>
  </ais-infinite-hits>
</template>

<script>
import Variations from './Variations.vue';
import {hasAppliedFilters} from '../utils';
import t from '../../main/i18n';

export default {
  components: {Variations},
  methods: {
    hasAppliedFilters(results) {
      return hasAppliedFilters(results._state);
    }
  },
  filters: {
    t
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/variables';
@import '../../../scss/system';

#variations {
  content: '';
  pointer-events: none;
  margin-top: -112px;
  padding-top: 112px;

  :deep(.product-actions .restriction-message) {
    display: none;
  }
}

.items {
  pointer-events: all;
}

:deep(.product-actions) {
  .slo-price-info {
    align-items: start;

    @media (min-width: $screen-md) {
      align-items: center;
    }
  }

  .price-info--price-wrapper {
    margin-block: 0;
  }

  .price-info--price {
    font-size: 1.6rem;
    font-weight: 500;
  }

  .unit-of-measure {
    font-size: 1.6rem;
  }
}
</style>
